const applicants = {
  applicantsList: "قائمة المتقدمين",
  listApplicants: {
    listApplicantsBreadcrumb: "قائمة المتقدمين",
    applicantsBreadcrumb: "المتقدمون",
    getKnowTeam: "تعرف على فريقنا!",
    name: "الاسم",
    email: "البريد الالكتروني",
    fullName: "الاسم بالكامل",
    profileStatus: "حاله الملف",
    verified: "تم التحقق",
    unverified: "لم يتم التحقق",
    profile_completed: "جميع معلومات الملف كاملة",
    basic_profile_completed: "معلومات الاساسية للملف  كاملة",
    applicantStatus: "حاله المتقدم",
    unblocked: "غير محظور",
    block: "محظور",
    assigned: "مُكلَف",
    notAssigned: "غير مُكلَف",
    nationality: "الجنسيه",
    studyField: "مجالات الدراسه",
    profileRate: "التققيم",
    role: "الوظيفه",
    note: "ملاحظة",
    tags: "الوسوم",
    tag: "الوسم",
    company: "الشركة",
    addTag: "إضافة وسم",
    gender: "الجنس",
    notProvided: "غير مُزود",
    male: "ذكر",
    female: "أنثى",
    prefer_not_to_say: "غير مُزود",
    language: "اللغه",
    speaking: "إجادة التحدث",
    age: "العمر",
    shift: "الوردية",
    zone: "المنطقة",
    ageRange1: "16 - 25",
    ageRange2: "25 - 30",
    ageRange3: "30 - 35",
    ageRange4: "35 - 40",
    height: "الطول",
    heightRange1: "140 - 160 سم",
    heightRange2: "160 - 180 سم",
    heightRange3: "180 - 200 سم",
    heightRange4: "200 -300 سم",
    weight: "الوزن",
    weightRange1: "40 - 50 كجم",
    weightRange2: "50 - 70 كجم",
    weightRange3: "70 - 100 كجم",
    weightRange4: "100 - 120 كجم",
    weightRange5: "120 - 170 كجم",
    disability: "اعاقه",
    diseases: "امراض",
    searchPlaceHolder: "ابحث عن طريق اسم المتقدم، ورقم هوية المتقدم",
    showingRange: "عرض {from}-{to} من أصل {total} متقدم",
    emptyState: {
      title: "لا يوجد متقدمون بعد",
      description:
        "لا يوجد متقدمون في النظام بعد. سيظهر المتقدمون هنا بمجرد تسجيلهم.",
    },
    filteredEmptyState: {
      title: "لا توجد نتائج",
      description:
        "لا يوجد متقدمون يطابقون معايير البحث أو التصفية. حاول تعديل البحث أو الفلاتر.",
    },
    noDataDescription: "عذرا لا يوجد متقدمين",
    noDisease: "لا توجد أمراض",
    noDisability: "لا توجد إعاقة",
    cityOfResidence: "المدينة",
    applicantPromotePrivileges:
      "هل أنت متأكد أنك تريد منح صلاحيات المسؤول لهذا المستخدم؟",
    applicantDemotePrivileges:
      "هل أنت متأكد أنك تريد إزالة صلاحيات المسؤول من هذا المستخدم؟",
    addShiftType: "إضافة نوع التحول",
    noShiftFound: "لم يتم العثور على التحول!",
  },
  applicantDetails: {
    applicantDetailsBreadcrumb: "تفاصيل المتقدم",
    editProfilePageTitle: "تعديل الملف الشخصي",
    applicantDetails: "تفاصيل المتقدم",
    totalHours: "اجمالي ساعات العمل",
    requests: "طلبات",
    events: "الفعاليات",
    rated: "التقييم",
    blockBtn: "حظر المتقدم",
    unBlockBtn: "الغاء حظر المتقدم",
    blockModalConfirmMessage: "هل أنت متأكد أنك تريد حظر هذا المتقدم؟",
    unBlockModalConfirmMessage: "هل أنت متأكد أنك تريد الغاء حظر هذا المتقدم؟",
    pendingRequests: "عرض الطلبات قيد الانتظار",
    showEvents: "عرض الفاعليات",
    downloadProfiles: "تنزيل الملفات الشخصية",
    downloadProfile: "تنزيل الملف الشخصي",
    applicantProfile: {
      labels: {
        basicInfo: {
          title: "معلومات أساسية",
          enName: "الاسم (الانجليزية)",
          arName: "الاسم (العربية)",
          firstName: "الاسم الأول (انجليزي)",
          middleName: "اسم الأب (انجليزي)",
          lastName: "الاسم الأخير (انجليزي)",
          firstNameAr: "الاسم الأول (عربي)",
          middleNameAr: "اسم الأب (عربي)",
          lastNameAr: "الاسم الأخير (عربي)",
          countryCode: "رمز الدولة",
          email: "البريد الإلكتروني",
          iqmaExpireDate: "تاريخ انتهاء الإقامة",
          stcNumber: "رقم STC",
          phoneNumber: "رقم الهاتف",
          nationalId: "رقم الهوية",
          iqamaNumber: "رقم الإقامة",
          expiryDate: "تاريخ الانتهاء",
          dateOfBirthHijri: "تاريخ الميلاد (هجري)",
          dateOfBirthGregorian: " تاريخ الميلاد (الميلادي)",
          matlooobNumber: "رقم مطلوب",
          nationality: "الجنسيه",
          role: "الوظيفه",
          gender: "الجنس",
          age: "العمر",
          height: "الطول",
          weight: "الوزن",
          disability: "اعاقه",
          diseases: "امراض",
          chronicDisease: "مرض مزمن",
          cityOfResidence: "مدينة الإقامة",
          autoDeduction: "الخصم التلقائي",
          notifiable: "قابل للإشعار",
        },
        educationInfo: {
          title: "معلومات شخصية",
          education: "مستوى التعليم",
          filedsOfStudy: "مجال الدراسة",
          fieldOfStudyName: "اسم مجال الدراسة",
        },
        languageInfo: {
          title: "مهارات لغوية",
          language: "اللغة",
          proficiency: "الإجادة",
          addLanguage: "إضافة لغة",
          removeLanguage: "إزالة اللغة",
          proficiencyLevels: {
            beginner: "مبتدئ",
            elementary: "أساسي",
            intermediate: "متوسط",
            advance: "متقدم",
            advanced: "متقدم",
            fluent: "طليق",
            native: "اللغة الأم",
          },
        },
        documentInfo: {
          title: "المستندات",
          certificates: "الشهادات",
          academicQualifications: "المؤهلات العلمية",
          cv: "السيرة الذاتية",
          other: "مستندات أخرى",
        },
        bankInfo: {
          title: "معلومات البنك",
          bankName: "اسم البنك",
          IBAN: "رقم الآيبان",
          cardHolder: "صاحب الحساب",
        },
      },
    },
  },
  applicantRequsets: {
    eventName: "اسم الفاعلية",
    role: "الوظيفة",
    requestDate: "تاريخ الطلب",
    actions: "أفعال",
    accepted: "مقبول",
  },
  applicantEvents: {
    eventName: "اسم الفعالية",
    eventStatus: "حالة الفعالية",
    role: "الوظيفة",
    totalWorkingHours: "اجمالي ساعات العمل",
    supervisorComments: "تعليقات المشرف",
    rating: "التقييم",
    notYetProvided: "غير مزود حاليا",
    evaluationRounds: "جولات التقييم",
    round: "جولة ",
    evaluationForm: "استمارة التقييم",
  },
  search: "أبحث باستخدام اسم الفاعلية",
  saveChanges: "حفظ التغييرات",
  applicantExportDetails: {
    applicantProfile: "ملفات تعريف المتقدمين",
    basicInfo: "معلومات أساسية",
    gender: "الجنس",
    nationality: "الجنسية",
    city: "المدينة",
    iqamaNumber: "رقم الإقامة",
    phoneNumber: "رقم الهاتف",
    id: "الهوية",
    education: "التعليم",
    educationLevel: "المستوى التعليمي",
    filedsOfStudy: "مجالات الدراسة",
    language: "اللغة",
    bankInfo: "معلومات البنك",
    bankName: "اسم البنك",
    bankIban: "رقم الآيبان",
    bankCardHolder: "اسم حامل البطاقة",
    profile: "حساب تعريفي",
  },
  placeholders: {
    enterFirstName: "أدخل الاسم الأول",
    enterMiddleName: "أدخل الاسم الأوسط",
    enterLastName: "أدخل الاسم الأخير",
    enterFirstNameAr: "أدخل الاسم الأول بالعربية",
    enterMiddleNameAr: "أدخل الاسم الأوسط بالعربية",
    enterLastNameAr: "أدخل الاسم الأخير بالعربية",
    selectNationality: "اختر الجنسية",
    selectCity: "اختر المدينة",
    enterCountryCode: "أدخل رمز الدولة",
    enterPhoneNumber: "أدخل رقم الهاتف",
    enterMatloobNumber: "أدخل رقم مطلوب",
    selectRole: "اختر الدور",
    selectGender: "اختر الجنس",
    enterNationalId: "أدخل رقم الهوية الوطنية",
    enterHeight: "أدخل الطول",
    enterWeight: "أدخل الوزن",
    enterIqamaNumber: "أدخل رقم الإقامة",
    selectMedicalCondition: "اختر الحالة الصحية",
    selectDisability: "اختر الإعاقة",
    selectBank: "اختر البنك",
    enterIban: "أدخل رقم الآيبان",
    enterCardHolderName: "أدخل اسم صاحب البطاقة",
    selectFieldOfStudy: "اختر مجال الدراسة",
    enterFieldOfStudy: "أدخل مجال الدراسة",
    enterStcNumber: "أدخل رقم STC",
    selectLanguage: "اختر اللغة",
    selectProficiency: "اختر مستوى الإتقان",
    selectIqamaExpiryDate: "اختر تاريخ انتهاء الإقامة",
    selectDateOfBirthPlaceholder: "اختر تاريخ الميلاد",
    selectCompanyWorkedWith: "اختر الشركة",
    nationalIdExpireDatePlaceholder: "تاريخ انتهاء رقم الهوية",
  },
  loyalApplicants: {
    pageTitle: "قائمة المتقدمين الموالين",
    breadcrumb: "قائمة المتقدمين الموالين",
    searchPlaceholder: "البحث بالاسم أو رقم الهوية",
    columns: {
      id: "رقم الهوية",
      name: "الاسم",
      nationality: "الجنسية",
      role: "الدور",
      rating: "التقييم",
      tags: "الوسوم",
      addTag: "إضافة وسم",
    },
    filters: {
      allocation: "التخصيص",
      nationality: "الجنسية",
      role: "الدور",
      tag: "الوسم",
    },
    showingRange: "عرض {from}-{to} من {total} متقدم",
    noDataDescription: "لا يوجد متقدمون مخلصون.",
    noDataSubDescription: "سيظهر المتقدمون الذين يستوفون معايير الولاء هنا تلقائيًا.",
    bulkActions: {
      selectedLabel: "{count} محدد",
      downloadProfile: "تحميل الملف الشخصي",
      editTags: "إضافة/تعديل وسم",
      deleteTags: "حذف الوسوم",
      remove: "إزالة",
    },
    removeModal: {
      title: "تأكيد الإزالة",
      messageSingle:
        "هل أنت متأكد أنك تريد إزالة هذا المتقدم من قائمة المتقدمين المخلصين؟",
      messageMultiple:
        "هل أنت متأكد أنك تريد إزالة {count} متقدمين من قائمة المتقدمين المخلصين؟",
      confirm: "تأكيد",
      cancel: "إلغاء",
      successSingle: "تمت إزالة 1 مستخدم من القائمة بنجاح.",
      successMultiple: "تمت إزالة {count} مستخدم من القائمة بنجاح.",
    },
  },
  companyApplicantProfile: {
    breadcrumbApplicants: "المتقدمون",
    profileTitle: "ملف المتقدم",
    profileNotFound: "الملف غير موجود",
    profileNotFoundDescription: "تعذر تحميل ملف هذا المتقدم.",
    backToApplicants: "العودة إلى قائمة المتقدمين",
    contactPerson: "بيانات الاتصال",
    identity: "الهوية",
    dateOfBirth: "تاريخ الميلاد",
    physicalDetails: "البيانات الجسدية",
    residencyId: "هوية الإقامة",
    companyWorkedWith: "الشركة التي عمل بها",
    fieldLabels: {
      nameEn: "الاسم بالإنجليزية",
      nameAr: "الاسم بالعربية",
      nationality: "الجنسية",
      age: "العمر",
      email: "البريد الإلكتروني",
      phoneNumber: "رقم الهاتف",
      nationalId: "رقم الهوية",
      stcNumber: "رقم STC",
      gregorian: "ميلادي",
      hijri: "هجري",
      weight: "الوزن",
      height: "الطول",
      iqamaNumber: "رقم الإقامة",
      iqamaExpiry: "انتهاء الإقامة",
      matloobNumber: "رقم مطلوب",
    },
    healthAccessibility: "الصحة وإمكانية الوصول",
    hasMedicalCondition: "لديه حالة مرضية / مرض",
    medicalConditionDetails: "تفاصيل الحالة المرضية",
    hasDisability: "لديه إعاقة",
    disabilityDetails: "تفاصيل الإعاقة",
    noneReported: "لا يوجد",
    noMedicalCondition: "لا توجد حالة مرضية / مرض",
    noDisability: "لا توجد إعاقة",
    expired: "منتهية",
    iqamaExpired: "الإقامة منتهية",
    verified: "موثّق",
    unverified: "غير موثّق",
    assigned: "مُكلَّف",
    roleLabel: "الدور",
    pendingRequests: "الطلبات المعلقة",
    attendance: "الحضور",
    workingHours: "ساعات العمل",
    profileCompleteness: "اكتمال الملف",
    completeStatus: "مكتمل",
    completeLabel: "اكتمال {percent}%",
    fieldsMissing: "{count} حقول ناقصة",
    missingRequiredFields: "حقول مطلوبة ناقصة",
    missingOptionalFields: "حقول ناقصة",
    notProvided: "غير متوفر",
    required: "مطلوب",
    documentAvailable: "متاح",
    downloadDocument: "تنزيل المستند",
    uploadDocument: "رفع مستند",
    documentUploadFailed: "فشل رفع المستند. يرجى المحاولة مرة أخرى.",
    copyIban: "نسخ رقم الآيبان",
    ibanCopied: "تم نسخ رقم الآيبان",
    autoDeductionDescription: "تفعيل الخصم التلقائي من الرواتب لهذا المتقدم",
  },
};

export default applicants;
